import DistrictService from "@/service/DistrictService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { District } from "@/model/District";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import districtValidationObj from "./S080800-DistrictValidation.js";
import Paginate from "vuejs-paginate";
import Settings from "../../../constants/Settings.js";
var districtDataValidationObj = new districtValidationObj();
export default {
  name: "district",
  mounted() {
    districtDataValidationObj.districtValidation();
    this.assignRights();
    this.resetDistrictData();
    this.init();
    this.getAllDistrict();
  },
  components: {
    paginate: Paginate,
  },
  data: () => ({
    menuRights: { allRights: {}, rightsForThisMenu: {} },
    menuId: Settings.MenuID.S_District,
    Settings: Settings,
    dictEnum: dictEnum,
    district: new District(),
    isEditMode: false,
    districtList: [],
    selectAllDistrict: false,
    tempDistrictModel: new District(),
    take: 10,
    skip: 0,
    totalNoOfPages: 0,
    noOfPages: 5,
    currentSelectedPage: 0,
    currentPage: 1,
    totalRecords: 0,
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  methods: {
    init() {
      var self = this;
      var documentHeight = $(document).height();
      var headerHeight = $("nav").height();
      var tabHeight = $(".tab-header-section").height();
      var tableHeaderHeight = $(".district-table table thead").height();
      var pagginationHeight = $(".paggination-district").height();
      var docHeight = documentHeight != undefined ? documentHeight : 666;
      var headHeight = headerHeight != undefined ? headerHeight : 59;
      var tabHeaderHeight = tabHeight != undefined ? tabHeight : 36;
      var tHeadHeight = tableHeaderHeight != undefined && tableHeaderHeight != 0 ? tableHeaderHeight : 38;
      var paggHeight = pagginationHeight != undefined && pagginationHeight != 0 ? pagginationHeight : 22;
      var tableHeight = docHeight - headHeight - tabHeaderHeight - tHeadHeight - paggHeight - 70;
      self.take = Number((tableHeight / 39).toFixed());
    },
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async getAllDistrict() {
      var self = this;
      var obj = {
        take: self.take,
        skip: self.skip,
      }
      const response = await DistrictService.getAllDistrictByPagination(obj);
      if (response.data.IsSuccess) {
        self.districtList = response.data.Data.Item1;
        self.totalRecords = response.data.Data.Item2;
        self.totalPages();
        if (response.data.Data.Item1.length == 0 && response.data.Data.Item2 > 0) {
          self.changePage(1);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDistrictDetail() {
      var self = this;
      const obj = {
        country: self.tempDistrictModel.Country,
        districCode: self.tempDistrictModel.District,
        area: self.tempDistrictModel.Area,
      };
      const response = await DistrictService.getDistrictDetail(obj);
      if (response.data.IsSuccess) {
        self.district = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    selectAllDistrictRecord: function () {
      var self = this;
      var IsSelected = self.selectAllDistrict;
      self.districtList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    deleteMultipleDistrictPopup: function () {
      var arrayList = [];
      var self = this;
      self.districtList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteDistrictModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
      }
    },
    async deleteMultipleDistrict() {
      var arrayList = [];
      var self = this;
      $('#deleteDistrictModel').modal('hide');
      self.districtList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      const obj = {
        districtList: arrayList,
      };
      const response = await DistrictService.deleteDistrict(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDistrictData();
        self.init();
        await self.getAllDistrict();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnDistrictSelect: function (model) {
      this.tempDistrictModel = model;
    },
    addDistrict: function () {
      var self = this;
      $('#districtModel').modal('show');
      self.isEditMode = false;
      self.district = new District();
      self.$validator.reset();
      self.vErrors.clear();
    },
    async saveDistrictData(obj) {
      var self = this;
      const response = await DistrictService.addDistrict(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDistrictData();
        self.init();
        await self.getAllDistrict();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async EditDistrictData(obj) {
      var self = this;
      const response = await DistrictService.updateDistrict(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        self.resetDistrictData();
        self.init();
        await self.getAllDistrict();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async saveDistrict() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          $('#districtModel').modal('hide');
          const obj = {
            model: {
              Country: self.district.Country,
              District: self.district.District,
              Area: self.district.Area,
              AreaDesc: self.district.AreaDesc,
              AreaChiDesc: self.district.AreaChiDesc,
            }
          };
          if (self.isEditMode) {
            self.EditDistrictData(obj);
          }
          else {
            self.saveDistrictData(obj);
          }
        }
      });
    },
    async editDistrict() {
      var self = this;
      self.isEditMode = true;
      if (self.tempDistrictModel.Country != "") {
        await self.getDistrictDetail();
        self.$validator.reset();
        self.vErrors.clear();
        $('#districtModel').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
      }
    },
    resetDistrictData: function () {
      var self = this;
      self.selectAllDistrict = false;
      self.isEditMode = false;
      self.district = new District();
      self.tempDistrictModel = new District();
      self.$validator.reset();
      self.vErrors.clear();
      self.take = 10;
      self.skip = 0;
      self.totalNoOfPages = 0;
      self.noOfPages = 5;
      self.currentSelectedPage = 0;
      self.currentPage = 1;
      self.totalRecords = 0;
    },
    closeDistrictPopup: function () {
      var self = this;
      self.selectAllDistrict = false;
      self.isEditMode = false;
      self.district = new District();
      self.tempDistrictModel = new District();
      self.$validator.reset();
      self.vErrors.clear();
      $('#districtModel').modal('hide');
    },
    //Pagination Method start
    changePage(e) {
      this.currentPage = e;
      this.setPage();
    },
    setPage() {
      this.skip = this.take * (this.currentPage - 1);
      this.getAllDistrict();
    },
    totalPages() {
      var numbers = this.totalRecords / this.take;
      var pages = 0;
      if (Number.isInteger(numbers)) {
        pages = numbers;
      } else {
        pages = Math.floor(numbers) + 1;
      }
      this.totalNoOfPages = pages;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080800-District/S080800-District.js